var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"alert fade alert-danger show",attrs:{"role":"alert"}},[_c('div',{staticClass:"alert-text"},[_vm._v(" "+_vm._s(_vm.text || _vm.$t("GENERAL.GENERAL_ERROR"))+" ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }